import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getAuth } from 'firebase/auth'
import { serverUrl } from '../constants'

const auth = getAuth()
// Define a service using a base URL and expected endpoints
export const apiAdmin = createApi({
    reducerPath: 'apiAdmin',
    baseQuery: fetchBaseQuery({
        baseUrl: serverUrl,
        prepareHeaders: async (headers, { getState }) => {
            try {
                const token = await auth.currentUser.getIdToken()
                headers.set('Authorization', token)
                headers.set('Content-Type', `application/json`)
                return headers
            } catch (e) {
                return headers
            }
        }
    }),
    tagTypes: ['User', 'Users', 'KpiRatings', 'UserRatings'],
    endpoints: (builder) => ({
        getUser: builder.mutation({
            query: (body) => ({
                url: `adminUser`,
                method: 'GET',
                body
            }),
            providesTags: ['User'],
        }),
        orgs: builder.mutation({
            query: (body) => ({
                url: `organisations`,
                method: 'GET',
                body
            }),
            providesTags: ['Users'],
        }),
        kpiRatings: builder.mutation({
            query: (body) => ({
                url: `kpiRatings`,
                method: 'GET',
                body
            }),
            providesTags: ['KpiRatings'],
        }),
        ratingsData: builder.mutation({
            query: (body) => ({
                url: `userRatings`,
                method: 'GET',
                body
            }),
            providesTags: ['UserRatings'],
        }),
        users: builder.mutation({
            query: (body) => ({
                url: `users`,
                method: 'GET',
                body
            }),
            providesTags: ['Users'],
        }),
        userDetails: builder.mutation({
            query: (id) => ({
                url: `userDetails/${id}`,
                method: 'GET',
            }),
            providesTags: ['Users'],
        }),
        refetchLinkedInOrgs: builder.mutation({
            query: (body) => ({
                url: `refetchLinkedInOrgs`,
                method: 'POST',
                body
            }),
            // providesTags: ['Users'],
        }),
        createOrganization: builder.mutation({
            query: (body) => ({
                url: `organisation`,
                method: 'POST',
                body
            }),
            // providesTags: ['Users'],
        }),
        notifyUsers: builder.mutation({
            query: (body) => ({
                url: `notifyUsers`,
                method: 'POST',
                body
            }),
            // providesTags: ['Users'],
        }),
    })
})

export const { useGetUserMutation, useOrgsMutation, useKpiRatingsMutation, useRatingsDataMutation, useUsersMutation, useUserDetailsMutation,
    useRefetchLinkedInOrgsMutation, useCreateOrganizationMutation, useNotifyUsersMutation
} = apiAdmin